import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
// SASS
import './Styles/App.css';


// Router
import AppWithRouterAccess from './AppWithRouterAccess';
import { ErrorProvider, useError } from './contexts/ErrorContext';
import GlobalErrorModal from './Components/Shared/GlobalErrorModal';
import { setErrorHandler, setupInterceptors } from './interceptor';

function AppContent() {
  const { showError } = useError();

  useEffect(() => {
    // Set the error handler for the interceptor
    setErrorHandler(showError);
  }, [showError]);

  useEffect(() => {
    // Initialize interceptors only once when the app mounts
    setupInterceptors();
  }, []); // Empty dependency array ensures this runs only once

  return (
    <>
      <AppWithRouterAccess />
      <GlobalErrorModal />
    </>
  );
}

function App() {
  return (
    <ErrorProvider>
      <Router>
        <AppContent />
      </Router>
    </ErrorProvider>
  );
}

export default App
